<ng-container *ngIf="formStatus">
  <div *ngIf="formStatus.isSaved()">Vše uloženo.</div>

  <div *ngIf="formStatus.isSaving()">Ukládám...</div>

  <div *ngIf="formStatus.isNotOk()">Asistenci nebylo možné uložit.</div>
</ng-container>
